import { useRef } from 'react';
import { useInView } from 'framer-motion';
import { FadeContainer, FadeText } from 'components/CustomAnimations';
import AboutOathNumber from 'components/LottieElements/AboutOathNumber';

export const OurAlgorithm = () => {
  const sectionRef = useRef(null);
  const isInView = useInView(sectionRef, { once: true, margin: '-100px' });

  return (
    <div className="our-algorithm-content">
      <FadeContainer className="our-algorithm-title" inViewTrigger delay={0.3}>
        <FadeText className="eyebrow-text inkBlue" text="Our Algorithm" />
        <FadeText
          delay={0.3}
          progressive
          className="h2-dtm"
          text="Our Impact Score is calculated across 3 metrics:"
        />
      </FadeContainer>
      <div ref={sectionRef} className="our-algorithm-items">
        <FadeContainer className="our-algorithm-item" animateNow={isInView} delay={1}>
          <AboutOathNumber number={1} />
          <div className="our-algorithm-item-content">
            <FadeText className="h3-dtm" text="Competitiveness" />
            <FadeText
              className="h4-text"
              text="Additional funding is most effective in the closest races where a small number of votes could change the outcome. Oath uses polling, expert ratings, historic trends and other election forecasting to rate how competitive each race is likely to be."
            />
          </div>
        </FadeContainer>

        <FadeContainer className="our-algorithm-item" animateNow={isInView} delay={1.5}>
          <AboutOathNumber number={2} />
          <div className="our-algorithm-item-content">
            <FadeText className="h3-dtm" text="Stakes" />
            <FadeText
              className="h4-text"
              text="While every vote matters, turning out additional voters in some races may have a larger impact than others. Oath highly rates races that could determine control of an entire chamber or where one voter may have multiple close elections on their ballot."
            />
          </div>
        </FadeContainer>

        <FadeContainer className="our-algorithm-item" animateNow={isInView} delay={2}>
          <AboutOathNumber number={3} />
          <div className="our-algorithm-item-content">
            <FadeText className="h3-dtm" text="Financial Need" />
            <FadeText
              className="h4-text"
              text="We know there are limits to what money can accomplish in a tight race. Oath projects the optimal budget for each race by considering a variety of factors, such as the amount a candidate's opponent is raising and spending, and how much outside funding is pouring into the race."
            />
          </div>
        </FadeContainer>
      </div>
    </div>
  );
};
